/**
 * schedule模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const schedule = {
  // 检查日程
  checkSchedule(params) {
    return $http.post(`${global.API_URL}/sme/schedule/queryScheduleTaskCountByInstanceId`,params);
  },
  // 创建日程
  createSchedule(params) {
    return $http.post(`${global.API_URL}/sme/schedule/create`,params);
  },
  // 更新定时任务
  updateSchedule(params) {
    return $http.post(`${global.API_URL}/sme/schedule/update`,params);
  },
  // 下载Excel文件
  exportSchedule(params) {
    return $http.post(`${global.API_URL}/sme/schedule/export`,params,{responseType: 'arraybuffer'});
  },
  // 查询审批任务列表
  selectByAuditStatus(params) {
    return $http.post(`${global.API_URL}/sme/schedule/selectByAuditStatus`,params);
  },
  //日程列表分页
  pageScheduleManagement(params) {
    return $http.post(`${global.API_URL}/sme/schedule/page`,params);
  },
  //查看日志
  logView(params) {
    return $http.post(`${global.API_URL}/sme/timeSwitchLog/queryTimeSwitchLogByScheduleId`,params);
  },
  //日程删除
  deleteSchedule(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/schedule/delete`,param);
  },
  //编辑定时任务
  editSchedule(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/schedule/edit`,param);
  },
  // 查询执行类型
  queryPerformType() {
    return $http.post(`${global.API_URL}/sme/schedule/queryPerformType`);
  }
}

export default schedule;



// WEBPACK FOOTER //
// ./src/api/schedule.js